export const useScroll = () => {
    const scrollTo = (selector: string): void => {
        setTimeout(() => {
            const invalid_element: HTMLElement | null = document.querySelector(selector)

            if (invalid_element) {
                invalid_element.scrollIntoView({
                    behavior: 'smooth',
                })
            }
        }, 100)
    }

    return { scrollTo }
}
